angular.module('bmsApp.calendar').factory('CalendarSvc', function (CRUDSvc, CALENDAR_API) {

	return {
		bankHolidays: function (params) {
			return CRUDSvc.get(CALENDAR_API.BANK_HOLIDAYS, params);
		},
		serviceMaster: function (params) {
			return CRUDSvc.get(CALENDAR_API.SERVICE_MASTER, params);
		},
		allAnniversaries: function(params) {
			return CRUDSvc.get(CALENDAR_API.ALL_ANNIVERSARIES, params);
		},
		allEmployeesTrainingEvents: function (params) {
			return CRUDSvc.get(CALENDAR_API.ALL_EMPLOYEES_TRAINING_CALENDAR, params);
		},
		allEmployeesNonAttendanceEvents: function (params) {
			return CRUDSvc.get(CALENDAR_API.ALL_EMPLOYEES_NON_ATTENDANCE_CALENDAR, params);
		},
		allEmployeesCarEvents: function (params) {
			return CRUDSvc.get(CALENDAR_API.ALL_EMPLOYEES_CAR_CALENDAR, params);
		}
	};

}).constant('CALENDAR_API', {
	BANK_HOLIDAYS: 'api/calendar/bankHolidays',
	SERVICE_MASTER: 'api/calendar/serviceMaster',
	ALL_EMPLOYEES_TRAINING_CALENDAR: 'api/calendar/training/allEmployees',
	ALL_EMPLOYEES_NON_ATTENDANCE_CALENDAR: 'api/calendar/nonAttendance/allEmployees',
	ALL_EMPLOYEES_CAR_CALENDAR: 'api/calendar/car/allEmployees',
	ALL_ANNIVERSARIES: 'api/customer/calendarAnniversaries',
});
